"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleSublist = exports.StyleRedLine = exports.StyleNotification = exports.StyleName = exports.StyleLink = exports.StyleImg = exports.StyleFlex = exports.StyleArrow = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
var _variables = _interopRequireDefault(require("@webmotors/eleanor-ui/webmotors/_variables.json"));
const StyleLink = exports.StyleLink = _styledComponents.default.div.withConfig({
  displayName: "StyleLink",
  componentId: "sc-1stgzj4-0"
})(["height:40px;width:100%;padding:", ";display:flex;align-items:center;justify-content:space-between;color:", ";cursor:pointer;&:hover{background-color:", ";}@media ", "{padding:0px 8px;}"], _variables.default['$ds-padding-quark'], (0, _color.default)('gray-4'), (0, _color.default)('gray-2'), _responsive.default.lg);
const StyleName = exports.StyleName = _styledComponents.default.p.withConfig({
  displayName: "StyleName",
  componentId: "sc-1stgzj4-1"
})(["font-family:Figtree;font-size:14px;font-style:normal;font-weight:400;line-height:120%;color:", ";display:block;margin-left:8px;@media ", "{margin-left:8px;display:", ";}"], (0, _color.default)('white'), _responsive.default.lg, _ref => {
  let {
    pinnedMenu,
    showPin
  } = _ref;
  return pinnedMenu || showPin ? 'block' : 'none';
});
const StyleImg = exports.StyleImg = _styledComponents.default.img.withConfig({
  displayName: "StyleImg",
  componentId: "sc-1stgzj4-2"
})(["width:24px;height:24px;-webkit-transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;transition:all .3s ease-in-out;"]);
const StyleSublist = exports.StyleSublist = _styledComponents.default.ul.withConfig({
  displayName: "StyleSublist",
  componentId: "sc-1stgzj4-3"
})(["padding:0;overflow:hidden;text-transform:none;height:0;&.cockpit-menu-animation{transition:height 0.3s,padding 0.3s;}&.cockpit-menu-open{height:auto;padding:8px 0;}"]);
const StyleNotification = exports.StyleNotification = _styledComponents.default.div.withConfig({
  displayName: "StyleNotification",
  componentId: "sc-1stgzj4-4"
})(["margin-left:8px;z-index:0;"]);
const StyleArrow = exports.StyleArrow = _styledComponents.default.div.withConfig({
  displayName: "StyleArrow",
  componentId: "sc-1stgzj4-5"
})(["width:24px;height:24px;background-color:", ";-webkit-mask-image:url('/assets/img/icons/arrow-right.svg');mask-image:url('/assets/img/icons/arrow-right.svg');display:block;@media ", "{display:", ";}&.cockpit-menu-open{transform:rotate(-92deg);-webkit-transition:all .3s ease-in-out;-moz-transition:all .3s ease-in-out;transition:all .3s ease-in-out;}"], (0, _color.default)('white'), _responsive.default.lg, _ref2 => {
  let {
    pinnedMenu,
    showPin
  } = _ref2;
  return pinnedMenu || showPin ? 'block' : 'none';
});
const StyleFlex = exports.StyleFlex = _styledComponents.default.div.withConfig({
  displayName: "StyleFlex",
  componentId: "sc-1stgzj4-6"
})(["display:flex;align-items:center;"]);
const StyleRedLine = exports.StyleRedLine = _styledComponents.default.span.withConfig({
  displayName: "StyleRedLine",
  componentId: "sc-1stgzj4-7"
})(["width:3px;height:36px;background-color:", ";margin:0px 4px 0px -8px;border-radius:8px;"], (0, _color.default)('primary'));